import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/prefer-default-export */
import { OV_ALERT, TEXT as GLOBAL_TEXT } from '../../config/constants';
import * as Sentry from '@sentry/browser';
import { DG_GC_SKU, fetchOptions, giftWrapItem, PHYS_GC_SKU, TEXT } from './constants';
export var changeOptions = function changeOptions(id, quantity) {
  return _objectSpread(_objectSpread({}, fetchOptions), {}, {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: "id=".concat(id, "&quantity=").concat(quantity)
  });
};
export var getContinueShoppingURL = function getContinueShoppingURL() {
  var _document = document,
      _document$referrer = _document.referrer,
      referrer = _document$referrer === void 0 ? 'ov' : _document$referrer;
  var cameFromOV = referrer.indexOf('outdoorvoices.com');
  var url = cameFromOV >= 0 ? referrer : '/collections/new-arrivals';
  return {
    cameFromOV: cameFromOV,
    url: url
  };
};
export var fetchError = function fetchError(type, exception) {
  if (Sentry) {
    Sentry.captureException(exception);
  }

  var event = new CustomEvent(OV_ALERT, {
    detail: GLOBAL_TEXT.alertCX
  });
  window.dispatchEvent(event);
};
export var getProcessItemIndex = function getProcessItemIndex(items, variant) {
  return items.findIndex(function (_ref) {
    var key = _ref.key;
    return key === variant.key;
  }) + 1;
};
export var isDonation = function isDonation(sku) {
  return (sku === null || sku === void 0 ? void 0 : sku.indexOf('YMCAOV')) > -1 || false;
};
export var isDigitalGiftCard = function isDigitalGiftCard(sku) {
  return sku && sku.indexOf(DG_GC_SKU) > -1;
};
export var isPhysicalGiftCard = function isPhysicalGiftCard(sku) {
  return sku && sku.indexOf(PHYS_GC_SKU) > -1;
};
export var isGiftCard = function isGiftCard(sku) {
  return isDigitalGiftCard(sku) || isPhysicalGiftCard(sku);
};
export var isGiftWrapped = function isGiftWrapped(items) {
  return !!items.find(function (item) {
    return item.id === giftWrapItem.id;
  });
};
export var isKitItem = function isKitItem(_ref2) {
  var properties = _ref2.properties;
  return properties && properties.kitRef !== undefined;
};
export var onConfirmLeave = function onConfirmLeave() {
  return TEXT.confirmLeave;
}; // cart entry page

export var updateLineItems = function updateLineItems(itemsJSON) {
  var items = [];
  var itemsToFilter = [];
  var cartAlreadyHasGWP = false;
  itemsJSON.forEach(function (item) {
    var compareAtPrice = item.compareAtPrice,
        finalSale = item.finalSale,
        gwp = item.gwp;

    if (gwp && !cartAlreadyHasGWP) {
      // Find any items in the cart with the id of the GWP data.
      var gwpItem = itemsJSON.find(function (ite) {
        return ite.variant_id === gwp.variant;
      }) || false;
      gwp.item = gwpItem; // if the gwp exists, add it to the filter.

      if (gwpItem) {
        cartAlreadyHasGWP = true;
        itemsToFilter.push(gwpItem);
      }

      items.push(_objectSpread(_objectSpread({}, item), {}, {
        compareAtPrice: compareAtPrice,
        finalSale: finalSale,
        gwp: gwp
      }));
    } else {
      items.push(_objectSpread(_objectSpread({}, item), {}, {
        compareAtPrice: compareAtPrice,
        finalSale: finalSale,
        gwp: false
      }));
    }
  });
  return [items, itemsToFilter];
};
export var getCustomCartInfo = function getCustomCartInfo(items) {
  var groupedItems = {}; // let eligibleForDTHat = false;

  var autoRemoveGiftWrap = false;
  var giftCards = [];
  var digitalGiftCards = [];
  var physicalGiftCards = [];
  var orderHasGiftWrap = false;
  var orderHasDigitalGiftCard = false;
  var orderHasPhysicalGiftCard = false; // let orderHasDTHat = false;

  var orderHasGWP = false;
  var orderHasGiftCard = false;
  var orderHasKits = false;
  var requiresShipping = false;
  var totalItems = 0;
  items.forEach(function (item) {
    var _item$gwp;

    var properties = item.properties ? item.properties : {};
    var kitRef = properties.kitRef;
    totalItems = totalItems + parseInt(item.quantity, 10);
    var digitalGC = isDigitalGiftCard(item.sku);
    var physicalGC = isPhysicalGiftCard(item.sku);
    var giftCard = digitalGC || physicalGC;
    groupedItems[kitRef] = groupedItems[kitRef] || [];
    groupedItems[kitRef].push(item);
    orderHasDigitalGiftCard = orderHasDigitalGiftCard || digitalGC;
    orderHasPhysicalGiftCard = orderHasPhysicalGiftCard || physicalGC;
    orderHasGiftWrap = orderHasGiftWrap || item.id === giftWrapItem.id;
    orderHasGiftCard = orderHasGiftCard || giftCard; // If the item has a gwp property AND the item has not been added to the cart already.

    orderHasGWP = orderHasGWP || (item === null || item === void 0 ? void 0 : (_item$gwp = item.gwp) === null || _item$gwp === void 0 ? void 0 : _item$gwp.item) === false;
    orderHasKits = orderHasKits || kitRef;
    requiresShipping = requiresShipping || item.requires_shipping;

    if (giftCard) {
      giftCards.push(item);
    }

    if (digitalGC) {
      digitalGiftCards.push(item);
    }

    if (physicalGC) {
      physicalGiftCards.push(item);
    } // DO NOT REMOVE
    // if the cart is eligible for the DT Hat, does it already have one?
    // eligibleForDTHat = item.freeDTHat || eligibleForDTHat;
    // orderHasDTHat = item.variant_id === DT_HAT_ID;

  }); // PGCs are shipped via CX and DGCs are not shipped.
  // Do not show Afterpay for gift-card-only purchases.

  var giftCardsOnly = orderHasGiftCard && giftCards.length === totalItems;
  autoRemoveGiftWrap = !requiresShipping || giftCardsOnly;
  var digitalGiftCardsOnly = orderHasDigitalGiftCard && digitalGiftCards.length === totalItems;
  var physicalGiftCardsOnly = orderHasPhysicalGiftCard && physicalGiftCards.length === totalItems;
  return {
    autoRemoveGiftWrap: autoRemoveGiftWrap,
    digitalGiftCardsOnly: digitalGiftCardsOnly,
    giftCards: giftCards,
    giftCardsOnly: giftCardsOnly,
    groupedItems: groupedItems,
    orderHasDigitalGiftCard: orderHasDigitalGiftCard,
    orderHasGiftCard: orderHasGiftCard,
    orderHasGiftWrap: orderHasGiftWrap,
    orderHasGWP: orderHasGWP,
    orderHasKits: orderHasKits,
    orderHasPhysicalGiftCard: orderHasPhysicalGiftCard,
    physicalGiftCardsOnly: physicalGiftCardsOnly,
    requiresShipping: requiresShipping,
    totalItems: totalItems
  };
};